import React, { Component } from "react";
import axios from "axios";
import qs from "querystring";
import config from "../axios/config";
import { Link } from "react-router-dom";
import cookies from "js-cookie";
import { Helmet } from "react-helmet";

class Login extends Component {
  state = {
    email: "",
    password: "",
  };
  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };
  handlePassChange = (event) => {
    this.setState({ password: event.target.value });
  };
  handleSubmit = async (event) => {
    event.preventDefault();
    const user = {
      email: this.state.email,
      password: this.state.password,
    };
    axios
      .post(
        `https://koalasurvey.herokuapp.com/company/login`,
        qs.stringify(user),
        config
      )
      .then((res) => {
        cookies.set("token", res.data[res.data.length - 1].token);
        cookies.set("id", res.data[res.data.length - 1]._id);
        config.headers.authorization = res.data[res.data.length - 1].token;
        window.location = "/profile";
      })
      .catch((error) => alert(error.response.data.error));
  };
  render() {
    return (
      <>
        <Helmet>
          <title>{window.location.pathname.split("/", 2)}</title>
        </Helmet>
        <section className="login">
          <div className="left">
            <h1>Login</h1>
            <div>
              <span>
                <input
                  onChange={this.handleEmailChange}
                  type="email"
                  placeholder="Email"
                />
                <p>Forgot email ?</p>
              </span>
              <span>
                <input
                  onChange={this.handlePassChange}
                  type="password"
                  placeholder="Password"
                />
                <p>Forgot password ?</p>
              </span>
              <Link
                to="/profile"
                className="primary"
                onClick={this.handleSubmit}
              >
                Login
              </Link>
            </div>
          </div>
          <div className="right">
            <div>
              <h1>
                Welcome Back! <span role="img">👋</span>
              </h1>
              <h2>
                if you don't have an account yet, why don't you make one ?
              </h2>
              <Link to="/Register" className="primary">
                Register
              </Link>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Login;
